import React from 'react';
import styled from 'styled-components';

const Spinner = () => {
  return (
    <Overlay>
      <Loader />
    </Overlay>
  );
};

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Loader = styled.div`
  width: 72px;
  height: 72px;
  position: relative;
  margin: auto;

  &:before {
    content: '';
    width: 72px;
    height: 7.5px;
    background: #803600;
    position: absolute;
    top: 84px; /* 72px + 12px gap */
    left: 0;
    border-radius: 50%;
    animation: shadow324 0.5s linear infinite;
  }

  &:after {
    content: '';
    width: 100%;
    height: 100%;
    background: #803600;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 6px; /* scaled from 4px to 6px */
    animation: jump7456 0.5s linear infinite;
  }

  @keyframes jump7456 {
    15% {
      border-bottom-right-radius: 4.5px; /* scaled from 3px */
    }
    25% {
      transform: translateY(13.5px) rotate(22.5deg); /* scaled from 9px */
    }
    50% {
      transform: translateY(27px) scale(1, 0.9) rotate(45deg); /* scaled from 18px */
      border-bottom-right-radius: 60px; /* scaled from 40px */
    }
    75% {
      transform: translateY(13.5px) rotate(67.5deg);
    }
    100% {
      transform: translateY(0) rotate(90deg);
    }
  }

  @keyframes shadow324 {
    0%, 100% {
      transform: scale(1, 1);
    }
    50% {
      transform: scale(1.2, 1);
    }
  }
`;

export default Spinner;
